// FaceLock Scan's look: calm and neutral, like an identity check (no
// landing-page flourish). Near-black surface, white text at 18 px or more,
// contrast above 7:1 for the main text, motion only when the reader allows it
// (Tailwind's motion-safe:).

export const SCAN_UI = {
  surface: "bg-[#0b0c0e] text-[#f4f5f7] text-[18px] leading-relaxed",
  panel: "border-[#2a2e35] bg-[#15171b]",
  mutedColor: "text-[#b4bac4]",
  muted: "text-[#b4bac4] text-[18px]",
  primaryButton:
    "inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-xl bg-[#f4f5f7] px-5 text-[18px] font-semibold text-[#0b0c0e] "
    + "focus:outline-none focus-visible:ring-4 focus-visible:ring-[#7cc4fa] disabled:cursor-not-allowed disabled:opacity-50",
  secondaryButton:
    "inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-xl border border-[#4a505a] bg-transparent px-5 text-[18px] font-semibold text-[#f4f5f7] "
    + "focus:outline-none focus-visible:ring-4 focus-visible:ring-[#7cc4fa] disabled:cursor-not-allowed disabled:opacity-50",
  ghostButton:
    "inline-flex min-h-[44px] items-center gap-1.5 rounded-lg border border-[#4a505a] px-3 text-[18px] font-semibold text-[#f4f5f7] "
    + "focus:outline-none focus-visible:ring-4 focus-visible:ring-[#7cc4fa]",
  iconButton:
    "inline-flex h-11 w-11 items-center justify-center rounded-full text-[#f4f5f7] hover:bg-white/10 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#7cc4fa]",
  good: "#3ddc97",
} as const;
